import React from 'react';

import BoxBody from 'components/BoxBody';
import Button from 'components/ButtonDeprecated';
import CoachingConstants from 'coaching/CoachingConstants';
import Divider from 'components/Divider';
import Row from 'components/Row';
import Text from 'components/Text';

type Props = {
  onCancelPlan: () => void;
};

export default function ManageRecurringSession({ onCancelPlan }: Props) {
  return (
    <>
      <BoxBody size="xsmall">
        <Row size="small">
          <Text>
            If you need to make scheduling adjustments to your overall plan, reach out to our
            Coaching team.
          </Text>
        </Row>
        <Button
          href={`${CoachingConstants.COACHING_HELP_FORM_ROUTE}?request=c_update_plan`}
          target="_blank"
          level="secondary"
          color="graphite"
          full>
          Request plan update
        </Button>
      </BoxBody>
      <Divider size="flush" />
      <BoxBody size="xsmall">
        <Button
          data-test="continue-to-cancel-plan"
          level="icon"
          color="apple"
          onClick={onCancelPlan}>
          <Text size="xxsmall">Cancel your coaching plan</Text>
        </Button>
      </BoxBody>
    </>
  );
}
